import { Injectable } from '@angular/core';
import {
  FreeNodePortLocationModel,
  IGraph,
  INode,
  IPort,
  Point,
} from '@yfiles/yfiles';
import { ProcessConnection } from '../models/business-process.model';
export interface ProcessPortConfiguration {
  inputPorts: ReadonlyMap<INode, readonly IPort[]>;
  outputPorts: ReadonlyMap<INode, readonly IPort[]>;
}
@Injectable({ providedIn: 'root' })
export class BusinessProcessPortService {
  configure(
    graph: IGraph,
    nodes: Iterable<INode>,
    connections: readonly ProcessConnection[],
  ): ProcessPortConfiguration {
    const inputPorts = new Map<INode, IPort[]>(),
      outputPorts = new Map<INode, IPort[]>(),
      incoming = new Map<INode, number>(),
      outgoing = new Map<INode, number>();
    // counted once, rather than searching every connection for each node
    for (const e of connections) {
      incoming.set(e.target, (incoming.get(e.target) ?? 0) + 1);
      outgoing.set(e.source, (outgoing.get(e.source) ?? 0) + 1);
    }
    for (const n of nodes) {
      const i = incoming.get(n) ?? 0,
        o = outgoing.get(n) ?? 0;
      inputPorts.set(n, this.create(graph, n, Math.max(i, 1), 0));
      outputPorts.set(n, this.create(graph, n, Math.max(o, 1), 1));
    }
    return { inputPorts, outputPorts };
  }
  private create(g: IGraph, n: INode, count: number, y: number) {
    const p: IPort[] = [];
    for (let i = 0; i < count; i++) {
      const x = count === 1 ? 0.5 : (i + 1) / (count + 1);
      p.push(
        g.addPort(
          n,
          FreeNodePortLocationModel.INSTANCE.createParameter(
            n,
            new Point(x, y),
          ),
        ),
      );
    }
    return p;
  }
}
